import * as api from "../api/notificationAPI";
import * as types from "../constants/notificationConstants";
import { getPendingNotifications } from "../api/notificationAPI";

export const getNotificationAction = () => async (dispatch) => {
    try {
        const { errorN, dataN } = await getPendingNotifications();
        if (errorN) {
            throw new Error(errorN);
        }
        // console.log("notification list",dataN)
        if (dataN) {
            dispatch({
                type: types.GET_NOTIFICATION_SUCCESS,
                payload: dataN,
            });
        }
    } catch (error) {
        dispatch({
            type: types.GET_NOTIFICATION_FAIL,
            payload: null,
        });
    }
};